// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"80b18827","628":"aacbb40c","640":"6c62c438","792":"f0eedf04"}[chunkId] + ".chunk.css";
};